"use client";

import { useEffect } from "react";
import { readMarketingCampaign } from "@/lib/signupAttribution";

/** Preserve an approved landing campaign before a pricing CTA supplies its placement. */
export function PricingCampaignCapture() {
  useEffect(() => { readMarketingCampaign(); }, []);
  return null;
}
